import React from 'react';
import { motion } from 'framer-motion';
interface AgeStepProps {
  onNext: (age: string) => void;
  defaultValue?: string;
}
export function AgeStep({
  onNext,
  defaultValue
}: AgeStepProps) {
  const ageRanges = ['25-34', '35-44', '45-54', '55-65', '65+'];
  return <div className="w-full max-w-md mx-auto px-4 py-1 sm:py-4" data-id="element-123">
      <div className="text-center mb-3 sm:mb-5" data-id="element-124">
        <h2 className="text-xl sm:text-3xl font-bold text-dark mb-1" data-id="element-125">
          ¿En qué grupo de edad estás?
        </h2>
        <p className="text-gray-600 font-medium text-sm" data-id="element-126">
          Ahorra hasta un 70% en tu seguro de vida
        </p>
      </div>
      <div className="space-y-1.5" data-id="element-127">
        {ageRanges.map((range, index) => <motion.button key={range} initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.07
      }} onClick={() => onNext(range)} className={`w-full bg-white p-3 sm:p-4 rounded-lg border-2 text-center transition-all duration-200 shadow-card hover:shadow-card-hover hover:scale-[1.02] ${defaultValue === range ? 'border-primary text-primary' : 'border-transparent hover:border-primary text-dark'}`} data-id="element-128">
            <span className="text-lg sm:text-xl font-semibold" data-id="element-129">{range}</span>
          </motion.button>)}
      </div>

      <div className="mt-2 text-center text-xs text-gray-500 flex items-center justify-center gap-1" data-id="element-130">
        <LockIcon className="w-3 h-3" data-id="element-131" />
        <span data-id="element-132">Tu información está cifrada</span>
      </div>
    </div>;
}
function LockIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-133">
      <rect width="18" height="11" x="3" y="11" rx="2" ry="2" data-id="element-134" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-135" />
    </svg>;
}